import { render, staticRenderFns } from "./base-empty.vue?vue&type=template&id=06d55096&"
import script from "./base-empty.vue?vue&type=script&lang=js&"
export * from "./base-empty.vue?vue&type=script&lang=js&"
import style0 from "./base-empty.vue?vue&type=style&index=0&id=06d55096&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports